import React, { useState } from "react";
import { localStoragePrefix } from "../../utils/GeneralFunc";

const AuthContext = React.createContext({
  userSessionId: "",
  isLoggedIn: false,
  userData: null,
  login: (userSessionId, userData) => {},
  anonlogin: (userSessionId) => {},
  logout: () => {},
});

export const AuthContextProvider = (props) => {
  const initialUserSessionId = localStorage.getItem(
    `${localStoragePrefix}userSessionId`
  );

  let initialUserdata = null;

  const storedUser = localStorage.getItem(
    `${localStoragePrefix}user`
  );

  if (storedUser) {
    initialUserdata = JSON.parse(storedUser);
  }

  const [userSessionId, setUserSessionId] =
    useState(initialUserSessionId);

  const [userData, setUserData] =
    useState(initialUserdata);

  const userIsLoggedIn =
    !!userSessionId && !!userData;

  const logoutHandler = () => {
    setUserSessionId(null);
    setUserData(null);
    

    localStorage.removeItem(
      `${localStoragePrefix}userSessionId`
    );

    localStorage.removeItem(
      `${localStoragePrefix}user`
    );

    localStorage.removeItem("addresses");
    localStorage.removeItem(`${localStoragePrefix}cart`);
    localStorage.removeItem(`${localStoragePrefix}cartItems`);
  };

  const loginHandler = (userSessionId, userData) => {
    setUserSessionId(userSessionId);
    setUserData(userData);

    console.log("-------------login handler--------------");

    console.log(
      `token: ${userSessionId}, userName: ${userData.username}, email: ${userData.email}`
    );

    localStorage.setItem(
      `${localStoragePrefix}userSessionId`,
      userSessionId
    );

    localStorage.setItem(
      `${localStoragePrefix}user`,
      JSON.stringify(userData)
    );
  };

  const loginAnonHandler = (userSessionId) => {
    setUserSessionId(userSessionId);

    const username = `guest${Math.floor(
      100000 + Math.random() * 9000
    )}`;

    const userlsData = JSON.stringify({
      user: username,
    });

    localStorage.setItem(
      `${localStoragePrefix}userSessionId`,
      userSessionId
    );

    localStorage.setItem(
      `${localStoragePrefix}user`,
      userlsData
    );
  };

  const contextValue = {
    userSessionId: userSessionId,
    isLoggedIn: userIsLoggedIn,
    userData: userData,
    login: loginHandler,
    logout: logoutHandler,
    anonlogin: loginAnonHandler,
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;

// import React, { useState } from "react";
// import { localStoragePrefix } from "../../utils/GeneralFunc";

// const AuthContext = React.createContext({
//   userSessionId: "",
//   isLoggedIn: false,
//   userData: {},
//   login: (userSessionId, userData) => {},
//   anonlogin: (userSessionId) => {},
//   logout: () => {},
// });

// export const AuthContextProvider = (props) => {
//   const initialUserSessionId = localStorage.getItem(
//     `${localStoragePrefix}userSessionId`
//   );

//   let initialUserdata;

//   if (localStorage.getItem(`${localStoragePrefix}user`)) {
//     initialUserdata = JSON.parse(
//       localStorage.getItem(`${localStoragePrefix}user`)
//     );
//   } else {
//     initialUserdata = false;
//   }

//   const [userSessionId, setUserSessionId] = useState(initialUserSessionId);
//   const [userData, setUserData] = useState(initialUserdata);
//   // const [user, setUser] = useState(initialUserdata);

//   const userIsLoggedIn = !!userSessionId;

//   const logoutHandler = () => {
//     setUserSessionId(null);
//     setUserData({});
//     localStorage.removeItem(`${localStoragePrefix}userSessionId`);
//     localStorage.removeItem(`${localStoragePrefix}user`);
//     localStorage.removeItem("addresses");
//     localStorage.removeItem(`${localStoragePrefix}cart`);
//     localStorage.removeItem(`${localStoragePrefix}cartItems`);
//   };

//   const loginHandler = (userSessionId, userData) => {
//     setUserSessionId(userSessionId);
//     setUserData(userData);
//     console.log("-------------login handler--------------");
//     console.log(
//       `token: ${userSessionId}, userName: ${userData.username}, email: ${userData.email} `
//     );
//     localStorage.setItem(`${localStoragePrefix}userSessionId`, userSessionId);
//     localStorage.setItem(`${localStoragePrefix}user`, JSON.stringify(userData));
//   };

//   const loginAnonHandler = (userSessionId) => {
//     setUserSessionId(userSessionId);
//     const username = `guest${Math.floor(100000 + Math.random() * 9000)}`;
//     const userlsData = JSON.stringify({ user: username });
//     // setUser(userlsData);
//     localStorage.setItem(`${localStoragePrefix}userSessionId`, userSessionId);
//     localStorage.setItem(`${localStoragePrefix}user`, userlsData);
//   };

//   const contextValue = {
//     userSessionId: userSessionId,
//     isLoggedIn: userIsLoggedIn,
//     userData: userData,
//     login: loginHandler,
//     logout: logoutHandler,
//     anonlogin: loginAnonHandler,
//   };

//   return (
//     <AuthContext.Provider value={contextValue}>
//       {props.children}
//     </AuthContext.Provider>
//   );
// };

// export default AuthContext;
